import React from 'react';
import PropTypes from 'prop-types';

const BonusStatus = ({ status }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 0:
        return 'fa-plus-square';
      case 1:
        return 'fa-check-square';
      default:
        return 'fa-question-circle';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 0:
        return 'text-info';
      case 1:
        return 'text-success';
      default:
        return 'text-secondary';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 0:
        return 'New: Activation pending';
      case 1:
        return 'Done: Activation complete';
      default:
        return 'Unknown';
    }
  };

  const statusIcon = getStatusIcon(status);
  const statusColor = getStatusColor(status);
  const statusText = getStatusText(status);

  return (
    <span title={statusText}>
      <i className={`fa ${statusIcon} ${statusColor}`}></i>
    </span>
  );
};

BonusStatus.propTypes = {
  status: PropTypes.number.isRequired,
};

export default BonusStatus;
